import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
export default class MentionableModel {
  constructor(format) {
    _defineProperty(this, "format", void 0);
    this.format = format;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/MentionableModel', MentionableModel);